import React from 'react';

const SvgTv: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 6.021a2 2 0 012 2M18 3.021c2.21 0 4 1.79 4 4M19 11.021v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-8a2 2 0 012-2h9M7 21.02h8" />
      </g>
    </svg>
  );
};

export default SvgTv;
